export default function ConcreteHeroContent() {
  return (
    <div className="space-y-6">
      <span className="inline-flex items-center gap-2 rounded-full border border-border px-3 py-1 font-mono-tech text-sm font-semibold uppercase tracking-[0.2em] text-foreground">
        <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
        Trust harness for finance
      </span>
      <h1 className="font-display text-5xl lg:text-7xl font-semibold tracking-[-0.02em] leading-[0.98] text-foreground">
        Your CRM and your billing system
        <br />
        <span className="text-primary">don&apos;t agree.</span>
      </h1>
      <div className="space-y-3 max-w-[34rem]">
        <p className="text-lg lg:text-xl text-foreground/75 leading-relaxed">
          Meshly catches the misalignment before it becomes a variance your
          team spends days reconciling. Works with Salesforce, Stripe,
          QuickBooks, and NetSuite, no migration needed.
        </p>
      </div>
    </div>
  );
}
